import React, {useEffect, useState} from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { createGame, updateGame, getGameById, getSystems } from '../../api/adminApi';
import common from '../../common.module.scss';
import {toast} from "react-toastify";
import {FaArrowLeft} from "react-icons/fa";
import useIsMobile from "@/shared/lib/hooks/useIsMobile";
import {compressImage} from "@/shared/lib/compressImage/compressImage.js";

export default function GameCardForm() {

    const { id } = useParams();
    const navigate = useNavigate();

    const isMobile = useIsMobile();

    const [form, setForm] = useState({
        title: '',
        description: '',
        gameSystemId: '',
        sessionFormat: '',
        gameFormat: '',
        cost: '',
        isActive: true,
        isVisible: true,
        isPrepayment: true,
    });
    const [image, setImage] = useState(null);
    const [compressedImage, setCompressedImage] = useState(null);
    const [systems, setSystems] = useState([]);

    const isEdit = Boolean(id);

    useEffect(() => {
        const fetchSystems = async () => {
            try {
                const res = await getSystems({ isActive: true });
                setSystems(res.data);
            } catch (err) {
                const errorMessage =
                    err?.response?.data?.message || 'Ошибка при загрузке систем';
                toast.error(errorMessage);
                console.error('Ошибка при загрузке систем', err);
            }
        };

        const fetchGame = async () => {
            try {
                const res = await getGameById(id);
                const game = res.data;
                setForm({
                    title: game.title,
                    description: game.description,
                    gameSystemId: game.gameSystemId,
                    sessionFormat: game.sessionFormatCode,
                    gameFormat: game.gameFormat,
                    cost: game.cost,
                    isActive: game.isActive,
                    isVisible: game.isVisible,
                    isPrepayment: game.isPrepayment,
                });
            } catch (err) {
                const errorMessage =
                    err?.response?.data?.message || 'Ошибка при загрузке сотрудников';
                toast.error(errorMessage);
                console.error('Ошибка загрузки карточки', err);
            }
        };

        fetchSystems();
        if (isEdit) fetchGame();
    },[id, isEdit] );

    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;
        setForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleFileChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        if (file.size > 10 * 1024 * 1024) {
            toast.error("Размер файла не должен превышать 10 МБ");
            return;
        }

        try {
            const compressedFile = await compressImage(file, 0.2);
            // console. log("Размер до:", (file. size / 1024).toFixed(2), "KB");
            // console. log("Размер после:", (compressedFile. size / 1024).toFixed(2), "KB");

            setCompressedImage(compressedFile);
        } catch (error) {
            console.error("Ошибка при сжатии изображения:", error);
            toast.error("Ошибка при сжатии изображения");
        }
    };




    const handleSubmit = async () => {
        const formData = new FormData();
        Object.entries(form).forEach(([key, value]) => formData.append(key, value));
        if (compressedImage) {
            formData.append('image', compressedImage);
            // console.log("фывыфв")
        }

        try {
            if (isEdit) {
                await updateGame(id, formData);
            } else {
                await createGame(formData);
            }
            navigate('/admin');
        } catch (err) {
            const errorMessage =
                err?.response?.data?.message || 'Ошибка при загрузке сотрудников';
            toast.error(errorMessage);
            console.error('Ошибка при сохранении карточки', err);
        }
    };

    return (
        <div className={`container ${common.container}`} id={"gamesRed"}>
            <span className="row">
                <span className="btn-word black btn-link col-md-auto col-2" onClick={() => navigate(-1)}>
                    <FaArrowLeft className={common.serviceButton}/>
                </span>
                <h2 className="col-md col-10">{isEdit ? 'Редактирование карточки' : 'Создание карточки игры'}</h2>
            </span>
            <div className="form-ckeck my-3">
                <input
                    type="checkbox"
                    className="form-check-input"
                    id={`isPrepayment`}
                    checked={form.isPrepayment}
                    name="isPrepayment"
                    onChange={handleChange}
                />
                <label
                    className={`form-check-label ms-2`}
                    htmlFor="isPrepayment">
                    Предоплата
                </label>
            </div>
            <div className="row mt-4">
                <div className="col-md-4">
                    <input
                        type="text"
                        className="form-control mb-3"
                        name="title"
                        placeholder="Название игры"
                        value={form.title}
                        onChange={handleChange}
                    />
                    <div className="form-check form-switch mb-3">
                        <input
                            id="accessType"
                            type="checkbox"
                            name={"isVisible"}
                            className="form-check-input"
                            checked={form.isVisible}
                            onChange={handleChange}
                        />
                        <label className="form-check-label ms-2" htmlFor="accessType">
                            Открытый доступ
                        </label>
                    </div>
                    <textarea
                        className="form-control mb-3"
                        name="description"
                        placeholder="Описание"
                        rows={5}
                        value={form.description}
                        onChange={handleChange}
                    />
                    {!isMobile && (
                        <button className="service-btn w-100" onClick={handleSubmit}>
                            Сохранить карточку
                        </button>
                    )}
                </div>

                <div className="col-md-4">
                    <select
                        className="form-control mb-3"
                        name="gameSystemId"
                        value={form.gameSystemId}
                        onChange={handleChange}
                    >
                        <option value={null}>Система</option>
                        {systems.map(sys => (
                            <option key={sys.id} value={sys.id}>{sys.name}</option>
                        ))}
                    </select>
                    <select
                        className="form-control mb-3"
                        name="sessionFormat"
                        value={form.sessionFormat}
                        onChange={handleChange}
                    >
                        <option value="">Категория</option>
                        <option value="ONESHOT">Ваншот</option>
                        <option value="CAMPAIGN">Кампейн</option>
                    </select>
                    <select
                        className="form-control mb-3"
                        name="gameFormat"
                        value={form.gameFormat}
                        onChange={handleChange}
                    >
                        <option value="">Формат</option>
                        <option value="ONLINE">Онлайн</option>
                        <option value="OFFLINE">Офлайн</option>
                        <option value="ONLINE_OFFLINE">Онлайн/офлайн</option>
                    </select>
                    <input
                        type="number"
                        className="form-control mb-3"
                        name="cost"
                        placeholder="Стоимость"
                        value={form.cost}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-md-4">
                    <label className="form-label">Загрузите изображение</label>
                    <input
                        type="file"
                        className="form-control mb-3"
                        accept="image/*"
                        onChange={(e) => {
                            handleFileChange(e)
                        }}
                    />
                    {image && (
                        <img
                            src={URL.createObjectURL(image)}
                            alt="Preview"
                            style={{ width: '100%', borderRadius: '6px' }}
                        />
                    )}
                </div>

                {isMobile && (
                    <button className="service-btn w-100 mt-5" onClick={handleSubmit}>
                        Сохранить карточку
                    </button>
                )}
            </div>
        </div>
    );
}
